// Allow Route to be accessed only by users with the role as Specified in Roles Allowed for that Route
import React from "react";
import { useSelector } from "react-redux";

const RoleBasedRoute = ({ Roles, children }) => {
  const { userInfo } = useSelector((state) => state.auth);
  const userRole = userInfo.role;
  const allowedRoles = Roles.includes(userRole) ? true : false;

  if (allowedRoles) {
    return children;
  }
  return (
    <div>
      {/* Tailwind Page 401 stating you dont have access to resource and contact admin */}

      <div className="flex flex-col items-center justify-center h-screen">
        <div className="text-5xl font-bold">401</div>
        <div className="text-2xl font-bold">Unauthorized</div>
        <p className="text-xl">
          You do not have access to this resource. Please contact your
          administrator.
        </p>
      </div>
    </div>
  );
};

export default RoleBasedRoute;
